import React, { useContext, useState } from "react";
import classNames from "classnames";

import { Block, Flex } from "/components/Layout";
import { Section } from "/components/Layout";
import OrderSykkelabo from "/forms/OrderSykkelabo";
import CreditCardForm from "/components/CreditCardForm";
import Image from "/components/cms/image";

import { BASE_URL } from "/constants";
import CartContext from "/context/cart";

import styles from "./Checkout.module.scss";
import { Temporal } from "@js-temporal/polyfill";

const Checkout = ({
  prevStep,
  customerHasValidCreditCard
}: {
  prevStep: () => void;
  customerHasValidCreditCard: boolean;
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const cart = useContext(CartContext);

  const bikeDeliveryDateString = cart.state.bike?.bike.bikeOrderEstimatedDeliveryDates?.sort()[0];
  const bikeDeliveryDate = bikeDeliveryDateString && new Date(bikeDeliveryDateString);

  const pickUpDateString = cart.state.bike?.bike.availableForPickupFrom?.sort()[0];
  const pickUpDate = pickUpDateString && new Date(pickUpDateString);

  const showCreditCardForm = !customerHasValidCreditCard && formSubmitted;

  const onFormSubmit = () => {
    setFormSubmitted(true);
  };

  return (
    <>
      <Section outer="none" limitedWidthSmall>
        <Block top={8}>
          <h2>Oppsummering</h2>

          {pickUpDate && (
            <p>
              Merk at denne sykkelen er klar for levering fra{" "}
              {pickUpDate.toLocaleDateString("no", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric"
              })}
              .
            </p>
          )}

          {!pickUpDate && bikeDeliveryDate && (
            <p>
              Merk at denne sykkelen er klar for levering i{" "}
              {bikeDeliveryDate.toLocaleString("no", { month: "long" })}.
            </p>
          )}

          {!pickUpDate && !bikeDeliveryDate && (
            <p>Vi tar kontakt angående levering når bestillingen er gjennomført.</p>
          )}
        </Block>
        <>
          <article>
            <Block>
              {cart.state?.accessories?.map((item) => {
                return (
                  <Block key={item.title} top={4}>
                    <div className={styles.productContainer}>
                      <div className={styles.productInnerContainer}>
                        <Flex>
                          <div className={styles.imageContainer}>
                            {item?.image ? (
                              <Image imagestyle={styles.image} imageObject={item?.image} />
                            ) : null}
                          </div>

                          <div>
                            <p className="body-quote">{item?.title}</p>
                            <p className="body-quote">{item?.quantity} x</p>
                          </div>
                        </Flex>
                        <Block left={4}>
                          <p className="body-quote font-family-medium">{item?.price} kr/mnd</p>
                        </Block>
                      </div>
                    </div>
                  </Block>
                );
              })}
            </Block>

            <Block top={4}>
              <div className={styles.productContainer}>
                <div className={styles.productInnerContainer}>
                  <div>
                    <Flex>
                      <div className={styles.imageContainer}>
                        {cart.state.bike.cms.image ? (
                          <Image
                            imagestyle={styles.image}
                            imageObject={cart.state.bike.cms.image}
                          />
                        ) : null}
                      </div>
                      <div>
                        <p className="body-quote">{cart.state.bike.cms.title}</p>
                        <p className="body-text">{cart.state.subscription.title}</p>
                      </div>
                    </Flex>
                  </div>

                  <Block left={4}>
                    <p className="body-quote font-family-medium">
                      {cart.state.subscription.price} kr/mnd
                    </p>
                  </Block>
                </div>
              </div>
            </Block>

            <Block top={4}>
              <div className={classNames(styles.productContainer, { [styles.total]: true })}>
                <div className={styles.productInnerContainer}>
                  <p data-testid="checkout-sum" className="body-quote">
                    Total sum
                  </p>
                  <p className="body-quote font-family-medium">{cart.total} kr/mnd</p>
                </div>
              </div>
            </Block>

            {showCreditCardForm ? (
              <CreditCardForm
                title="Registrer kredittkort for å fullføre bestillingen. Du blir ikke belastet før du henter
              sykkelen."
                ctaTitle="Bestill nå"
                clientSecret={cart.state.stripeFormClientSecret}
                prevStep={() => setFormSubmitted(false)}
                returnUrl={`${BASE_URL}/api/sykkelabonnement/payment`}
              />
            ) : (
              <OrderSykkelabo
                customerHasValidCreditCard={customerHasValidCreditCard}
                onFormSubmit={onFormSubmit}
                prevStep={prevStep}
              />
            )}
          </article>
        </>
      </Section>
    </>
  );
};

export default Checkout;
